import type { PropertyProcessStep, PropertyFaq } from '../types/propertyDetailTypes'

export const DEFAULT_PROPERTY_PROCESS_STEPS: PropertyProcessStep[] = [
  {
    step: 1,
    title: 'Purchase Tokens',
    description:
      'Select your investment amount and purchase fractional tokens representing your share of the property.',
  },
  {
    step: 2,
    title: 'Ownership Documents Issued',
    description:
      'Legal ownership documentation is issued and registered, confirming your fractional ownership via the SPV structure.',
  },
  {
    step: 3,
    title: 'Earn Rental Income',
    description:
      'Rental income is collected from tenants and distributed to all token holders proportionally on a quarterly basis.',
  },
  {
    step: 4,
    title: 'Track & Manage',
    description:
      'Monitor your portfolio performance, payout history, and property updates directly from your dashboard.',
  },
]

export const DEFAULT_PROPERTY_FAQS: PropertyFaq[] = [
  {
    question: 'How is ownership structured?',
    answer:
      'Each investment is structured through a regulated SPV that holds the underlying property while tokens represent your fractional exposure.',
  },
  {
    question: 'How do I receive rental income?',
    answer:
      'Net rental income is collected, accounted for, and distributed to token holders based on their ownership share.',
  },
  {
    question: 'Can I track my investment performance?',
    answer:
      'Yes. You can monitor portfolio value, distributions, and property-level updates directly from your investor dashboard.',
  },
]
